import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import { formatKey } from "./../../core/utils";
class BustypesPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Bustypes",
      state: "bustype",
      name: "bustype",
    };

    this.fields = [
      { name: "name", title: "Label", isSortable: true },
      { name: "seats", title: "Available Seats", isSortable: true },
      { name: "city", title: "City" },
      { name: "make", title: "Make" },
      { name: "model", title: "Model" },
      { name: "vehicle_type", title: "Vehicle Type" },
      { name: "is_ac", title: "Air Conditioning" },
    ];

    this.filters = [
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "search",
        title: "Search",
        icon: "search",
        resource: "Bustype",
        isSearch: true,
        state: "bustype",
      },
    ];
  }

  justify(data) {
    const getSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.is_ac = item.is_ac ? "Yes" : "No";
      item.vehicle_type = formatKey(item.vehicle_type);
      return item;
    };
    return map(getSource)(data);
  }
}

export default BustypesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bustypes/bustypes.transforms.js